import {
  AlertCircle,
  CheckCircle2,
  CircleDashed,
  Clock3,
  XCircle,
} from "lucide-react";

const verifiedStates = new Set(["verified", "approved", "active", "ready"]);
const warningStates = new Set([
  "pending",
  "in_review",
  "returned",
  "paused",
  "at_risk",
]);
const dangerStates = new Set([
  "rejected",
  "revoked",
  "dead",
  "failed",
  "exhausted",
  "overdue",
]);

export function StatusChip({ state }: { readonly state: string }) {
  const normalized = state.toLowerCase();
  const Icon = verifiedStates.has(normalized)
    ? CheckCircle2
    : dangerStates.has(normalized)
      ? XCircle
      : warningStates.has(normalized)
        ? AlertCircle
        : normalized === "draft"
          ? CircleDashed
          : Clock3;
  const tone = verifiedStates.has(normalized)
    ? "success"
    : dangerStates.has(normalized)
      ? "danger"
      : warningStates.has(normalized)
        ? "warning"
        : "neutral";
  return (
    <span className={`status-chip ${tone}`}>
      <Icon aria-hidden="true" />
      {state.replaceAll("_", " ")}
    </span>
  );
}
